import { Box, Flex, Icon, Collapse, useDisclosure } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronDown, ChevronRight } from '@kula-ai/icons-core';

export const CollapsibleSection = ({
  title = 'Details',
  children,
  defaultIsOpen = true,
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen });

  return (
    <Box
      borderRadius="xs"
      border="1px solid"
      borderColor="border-color"
      overflow="hidden"
    >
      <Flex
        onClick={onToggle}
        flex="1"
        p="12px 16px"
        cursor="pointer"
        bg="secondary-25"
        gap="6px"
        alignItems="center"
        borderBottom={isOpen && '1px solid'}
        borderColor="border-color"
      >
        <Icon
          width="16px"
          height="16px"
          cursor="pointer"
          as={isOpen ? ChevronDown : ChevronRight}
          onClick={onToggle}
        />
        <KText variant="heading_4" color="primary-900" fontWeight="semiBold">
          {title}
        </KText>
      </Flex>
      <Collapse in={isOpen} unmountOnExit={false}>
        {children}
      </Collapse>
    </Box>
  );
};
